var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiSelect',_vm._g({class:_vm.className,attrs:{"placeholder":_vm.placeholder,"options":_vm.options,"value":_vm.value,"show-labels":false,"label":_vm.labelBy,"track-by":_vm.trackBy,"openDirection":_vm.openDirection,"resetAfter":_vm.resetAfter,"searchable":_vm.searchable}},_vm.inputListeners))
}
var staticRenderFns = []

export { render, staticRenderFns }